
import { Component, Vue } from 'vue-property-decorator'
import { debounce, isNaN } from 'lodash'
import { ReporterService } from '@/services'
import { linear } from '@/common/utils'
import LoadMoreList from '@/components/load_more_list/index.vue'
import MorePopover from '@/components/load_more_popover/index.vue'

interface PassOption {
    name: string
}

const defaultOption: PassOption = {
    name: ''
}

@Component({
    name: 'related-reporter-dialog',
    components: {
        LoadMoreList,
        MorePopover
    }
})
export default class extends Vue {
    private suggestMap!: Map<any, any>
    private pageSize!: number
    private activeReporter: any

    private visible = false
    private linkLoading = false
    private focus = false
    private pageIndex = 1
    private pageTotal = 0
    private suggestList = []
    private viewOption = defaultOption
    private popverWidth = ''
    private query = ''
    private fetchSuggest: any = ''

    get hasMore() {
        return this.suggestList.length < this.pageTotal
    }
    get popverEl() {
        return this.$refs.morePopover as any
    }

    created() {
        this.activeReporter = null
        this.pageSize = 20
        this.fetchSuggest = debounce(async () => {
            this._reset()
            this.popverEl.showLoading()
            await linear(this.getSuggest)()
            this.popverEl.hideLoading()
        }, 300)
    }
    calcPopverWidth() {
        if (this.popverWidth) return
        this.popverWidth = (this.$refs.inputRef as any).$el.clientWidth
    }
    onLinkReporter() {
        if (isNaN(this.activeReporter)) {
            return this.$mwarning('请选择要关联的记者')
        }
        this.$emit('link', this.activeReporter)
    }
    onGetLoadMore() {
        this.pageIndex += 1
        this.getSuggest({ more: true })
    }
    async onInputFocus() {
        this.focus = true
        if (!this.suggestList.length) {
            this.popverEl.showLoading()
            await linear(this.getSuggest)()
            this.popverEl.hideLoading()
        }
        this.popverEl.show()
    }
    // 获取建议机构列表
    async getSuggest({ more } = { more: false }) {
        if (!this.query) return
        const self = this
        const params = {
            keyword: this.query,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await ReporterService.search(params)
        if (result.status === 200) {
            if (!result.data.results) return
            this.pageTotal = result.data.page_total
            if (more) {
                this.suggestList = this.suggestList.concat(result.data.results)
                concat(result.data.results)
            } else {
                this.suggestList = result.data.results
                this.suggestMap = toNewMap(result.data.results)
            }
        }
        // 把数组增加到 map 里
        function concat(list: any[]) {
            list.forEach(n => {
                self.suggestMap.set(n.id, n)
            }) 
        }
        // array to map
        function toNewMap(list: any[]) {
            let map = new Map()
            list.forEach(n => {
                map.set(n.id, n)
            })
            return map
        }
    }
    onInputBlur() {
        this.focus = false
    }
    // 选择建议
    onSelectSuggest(e: any) {
        const { id } = e.target.dataset
        if (!id) return
        const seletItem = this.suggestMap.get(+id)
        this.activeReporter = seletItem
        this.query = seletItem.name
        this.popverEl.close()
    }
    show(option: PassOption) {
        this.viewOption = { ...this.viewOption, ...option }
        this.visible = true
        this.$nextTick(() => {
            this.calcPopverWidth()
        })
    }
    close() {
        this.visible = false
        this.recover()
    }
    showLoading() {
        this.linkLoading = true
    }
    hideLoading() {
        this.linkLoading = false
    }
    recover() {
        this.linkLoading = false
        this.viewOption = defaultOption
    }
    _reset() {
        this.pageIndex = 1
        this.pageTotal = 0
        this.suggestList = []
        this.suggestMap = new Map()
    }
}
